/**
 * Created by PuTi(编程即菩提) 7/28/17.
 */
var nb = require('../../../nb');
var $ = nb.opts.$;
var imageItem = require('../view/MovieBanner').image;
var ImgItemModel = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            this.onChange('src', function (inEvent, inSrc) {
                this.set('url', 'url(' + inSrc + ')');
            }, this);

            this.onChange('ready', function (inEvent) {
                var video = this.get('video');
                video.set('itemReady', this.get('index'));
            }, this)
        }
    }
});

module.exports = nb.define({
    parent: nb.model.List,
    method: {
        init: function () {
            var self = this;
            this.set('loading', 'loading');
            this.set('itemType', imageItem);
            this.set('itemModelType', ImgItemModel);
           nb.model.onChange(nb.opts.clientReady,function () {
               setTimeout(function () {
                   var imgList = require('../../../data').getMovieList();
                   self.set('list',imgList);
               },5000);
           });
            this.onChange('list',function (inEvent) {
                var list = inEvent.data;
                $.each(list,function (index,item) {
                    var url = item.url;
                    item.src = url;
                });
                this.count = list.length;
                this.set('items',list);
            },this);
            this.onChange('itemReady', function (inEvent, inIndex) {
                var items = this.get('items');
                var ready = true;
                $.each(items, function (inIndex, inItem) {
                    if (!inItem.get('ready')) {
                        ready = false;
                        return false;
                    }
                });
                if (ready) {
                    setTimeout(function(){
                        self.set('allReady', true);
                        self.set('loading','');
                    },2000);

                }
            }, this);
            this.onChange('items',function (inEvent) {
                this.set('activeIndex', 0);
            },this);
            this.onChange('loading',function (inEvent) {
                var loading = inEvent.data;
                if (loading == 'loading') {
                    return;
                }

                self.set('maskState','play');
                self._play(0);
            },this);
        },
        createItemModel: function (inIndex, inItem) {
            var model = this.parent(inIndex, inItem);
            model.set('video', this);
            model.set('index', inIndex);
            return model;
        },
        _stop: function () {
            this.set('play', '');
            this.set('activeIndex', 0);
            clearTimeout(this._playTimeout);
        },
        _play: function (inIndex) {
            var self = this;
            var items = this.get('items');
            var length = items.length;
            var next = inIndex + 1;
            if (next == length) {
                next = 0;
            }
            this.set('activeIndex', next);
            this._playTimeout = setTimeout(function () {
                self._play(next);
            }, 40);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/MovieImgList.js
// module id = 403
// module chunks = 1